import axios from './axios'
import qs from "qs";

function service(endpoint) {
    function realize(id, data) {
        return axios.post(`${endpoint}/${id}/realize`, {},{ params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        realize
    }
}

export default service
